import TypeRegistry from '../utils/TypeRegistry';
import LocaleUtils from "../../qwc2/utils/LocaleUtils";
import FeatureUtils from "./FeatureUtils";
import ConfigUtils from "qwc2/utils/ConfigUtils";

const TypeUtils = {

    getTypeConfig(type) {
        const config = {
            type: type,
            tabs: []
        };
        const typeConfig = this.getConfig(type);
        if (typeConfig) {
            config.tabs = typeConfig.tabs;
        }

        if (config.tabs.length == 0) {
            config.tabs.push({
                label: LocaleUtils.trmsg("featuredetails.basisdata"),
                view: 'properties'
            });
        }

        return config;
    },

    getConfig(type) {
        if (TypeRegistry.data.types) {
            for (let i = 0; i < TypeRegistry.data.types.length; i++) {
                const typeConfig = TypeRegistry.data.types[i];
                if (typeConfig.type.toLowerCase() == type.toLowerCase()) {
                    return typeConfig;
                }
            }
        }
        return false;
    },

    getTypeLabel(type) {
        const typeConfig = this.getConfig(type);
        if (typeConfig) {
            if (typeConfig.typeLabel) {
                return typeConfig.typeLabel;
            }
        }
        return type;
    },

    getObjectLabel(type, item) {
        const typeConfig = this.getConfig(type);
        if (typeConfig) {
            let label = null;
            if (typeConfig.typeLabel) {
                label = typeConfig.typeLabel;
            }
            if (typeConfig.objectLabel) {
                label = typeConfig.objectLabel;
            }
            if (label) {
                if (item) {
                    label = FeatureUtils.genericResolve(item, label);
                    label = FeatureUtils.simpleProperty(item, label);
                }
                return label;
            }
        }
        return type;
    },
    getBreadcrumbUrl(feature, type) {
        const id = feature.properties.id || feature.id;
        return ConfigUtils.getConfigProp("parentServiceUrl") + '?ObjectType=' + type + '&uuid=' + id;
    }
};

export default TypeUtils;
